'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HubMap = require('self-service-api/constants/HubMap');

var _HubMap2 = _interopRequireDefault(_HubMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FEATURE_KEY_PREFIX = 'pricing-pages.features';
/*
  Features have their own descriptions which is the default. However,
  some features have a unique description depending on which hub it
  is attached to. Rather than have to attach feature
  descriptions to every single hub though, we model the data to
  represent this as it is in real life... by default each feature
  has its own description, and it can be overridden by having a
  more specific description tied to the hub. This utility helper
  helps black box that logic to implementations.
 */
var getFeatureDescriptionKey = function getFeatureDescriptionKey(featureKey, hubKey) {
  var hasHubSpecificFeature = _HubMap2.default[hubKey].hubSpecificFeatures.includes(featureKey);

  var descriptionKey = hasHubSpecificFeature ? hubKey : 'default';

  return FEATURE_KEY_PREFIX + '.' + featureKey + '.description.' + descriptionKey;
};

exports.default = getFeatureDescriptionKey;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/core/utilities/getFeatureDescriptionKey.js
// module id = 187
// module chunks = 3 4